import isNil from '~/_base/functions/isNil';
import ApiCall from '~/_base/functions/apicalls';
import ApiAddresses from '~/_base/constants/apiAddresses';
import getFiltersFromLocalStorage from '../functions/getFiltersFromLocalStorage';

export function initialised() {
  return {
    type: 'INITIALISED',
  };
}

function buildApiAddress(state, name) {
  const { filters } = state.Timetravel;
  const options = {};
  options.project_id = filters.project_id;
  options.startTime = filters.startTime;
  options.endTime = filters.endTime;
  options.templates = filters.templates;
  options.users = filters.users;

  const address = ApiAddresses({
    name: name,
    project_id: options.project_id,
    fromDate: options.startTime,
    toDate: options.endTime,
    templates: options.templates,
    users: options.users,
  });

  return address;
}

export function getProjectInfo() {
  return dispatch => {
    let address = ApiAddresses({
      name: 'current_project',
    });

    ApiCall(address, 'GET')
      .then(json => {
        dispatch(setCurrentProject(json));

        const filters = getFiltersFromLocalStorage(json.id);

        if (filters) {
          dispatch(setFilters(filters));
        }

        dispatch(getEventActivityData(json.id));
      })
      .catch(err => {
        console.error(err.message);
      });
  };
}

export function setCurrentProject(data) {
  return {
    type: 'SET_CURRENT_PROJECT',
    data,
  };
}

export function setGettingEventActivityData() {
  return {
    type: 'SET_GETTING_EVENT_ACTIVITY_DATA',
  };
}

export function getEventActivityData() {
  //console.log('Get event activity data')
  return (dispatch, getState) => {
    dispatch(setGettingEventActivityData());
    const state = getState();
    const address = buildApiAddress(state, 'project_activity');

    ApiCall(address, 'GET')
      .then(json => {
        if (!state.Timetravel.initialised) {
          dispatch(initialised());
        }
        dispatch(setEventActivityData(json));
      })
      .catch(err => {
        console.error(err.message);
      });
  };
}

export function setEventActivityData(data) {
  return {
    type: 'SET_EVENT_ACTIVITY_DATA',
    data,
  };
}

export function getMapData(options) {
  //console.log('Get map data')
  return (dispatch, getState) => {
    dispatch(setGettingMapData());

    if (options) {
      dispatch(
        setFilters({
          startTime: options.startTime,
          endTime: options.endTime,
        })
      );
    }

    const state = getState();
    const address = buildApiAddress(state, 'mapping_features');

    ApiCall(address, 'GET')
      .then(json => {
        dispatch(setMapData(json));
      })
      .catch(err => {
        console.error(err.message);
      });
  };
}

export function setGettingMapData() {
  return {
    type: 'SET_GETTING_MAP_DATA',
  };
}

export function setMapData(data) {
  return {
    type: 'SET_MAP_DATA',
    data,
  };
}

export function getFeedData(options) {
  //console.log('Get feed data')
  return (dispatch, getState) => {
    dispatch(setGettingFeedData());

    // will have options if coming from zoomableChart
    if (options) {
      dispatch(
        setFilters({
          startTime: options.startTime,
          endTime: options.endTime,
        })
      );
    }

    const state = getState();
    const address = buildApiAddress(state, 'live_feed');

    ApiCall(address, 'GET')
      .then(json => {
        dispatch(setFeedData(json));
      })
      .catch(err => {
        console.error(err.message);
      });
  };
}

export function setGettingFeedData() {
  return {
    type: 'SET_GETTING_FEED_DATA',
  };
}

export function setFeedData(data) {
  return {
    type: 'SET_FEED_DATA',
    data,
  };
}

export function filterFeatures(startDate, endDate) {
  return {
    type: 'FILTER_FEATURES',
    startDate,
    endDate,
  };
}

export function selectFeature(id) {
  return {
    type: 'SELECT_FEATURE',
    id,
  };
}

export function clearFeatureSelection() {
  return {
    type: 'CLEAR_FEATURE_SELECTION',
  };
}

export function setFilters(options, clear) {
  return {
    type: 'SET_FILTERS',
    options,
    clear,
  };
}

export function queryWithFilters(options, clear) {
  return dispatch => {
    dispatch(setFilters(options, clear));
    dispatch(getEventActivityData());
    dispatch(getFeedData());
    dispatch(getMapData());
  };
}

export function clearChartUpdated() {
  return {
    type: 'CLEAR_CHART_UPDATED',
  };
}
